import { PartnerFinances, User } from 'types/state';
import { m8API } from 'services/production/m8';
import { normalizeM8UserProfile } from 'services/production/utils/normalizeM8UserProfile';
import { normalizeM8AccountInfo } from 'services/production/utils/normalizeM8AccountInfo';
import { normalizeM8PartnerDTO } from 'services/production/utils/normalizeM8PartnerDTO';
import { createPartnerProfile } from 'utils/partnerProfileUtils';
import { normalizeM8PartnerBalance } from '../utils/normalizeM8PartnerBalance';
import { createPartnerFinances } from 'utils/partnerFinancesUtils';
import { PartnerFinanceMonthReport } from 'types/partnerFinance';
import { normalizeM8PartnerIncomeHistoryRecord } from '../utils/normalizeM8PartnerIncomeHistory';

export const getUser = async (): Promise<User> => {
  const m8AccountInfo = await m8API.user.getAccountInfo();

  const accountInfo = normalizeM8AccountInfo(m8AccountInfo).toUserAccountInfo();

  let profileInfo,
    org,
    person,
    partnerProfile = createPartnerProfile(),
    partnerFinances: null | PartnerFinances = null,
    partnerFinanceMonthReports: PartnerFinanceMonthReport[] = [],
    partnerCode = '',
    cancelledClientsCount = 0;

  if (accountInfo.roles.includes('CLIENT')) {
    const m8ProfileInfo = await m8API.user.getQuestionnaireInfo();

    profileInfo = normalizeM8UserProfile(m8ProfileInfo).toUserProfileInfo();

    if (m8ProfileInfo.organization !== null) {
      org = normalizeM8UserProfile(m8ProfileInfo).toOrg();
    }

    if (m8ProfileInfo.firstName !== null) {
      person = normalizeM8UserProfile(m8ProfileInfo).toPerson();
    }
  }

  if (accountInfo.roles.includes('PARTNER')) {
    const [
      m8PartnerDTO,
      m8CancelledClientsCount,
      avatarURL,
      m8PartnerBalance,
    ] = await Promise.all([
      m8API.partner.me(),
      m8API.partner.getCancelledClientsCount(),
      m8API.partner.getPartnerAvatarURL(),
      m8API.partner.getPartnerBalance(),
    ]);

    partnerFinances =
      m8PartnerBalance !== null
        ? normalizeM8PartnerBalance(m8PartnerBalance).toPartnerFinances()
        : createPartnerFinances();

    partnerProfile = normalizeM8PartnerDTO(m8PartnerDTO).toPartnerProfile(
      avatarURL || undefined
    );

    partnerCode = m8PartnerDTO.partnerCode || '';

    cancelledClientsCount = m8CancelledClientsCount;

    for (let page = 0; page >= 0; page += 1) {
      const m8PartnerIncomeHistoryRecords = await m8API.partner.getPartnerIncomeHistory(
        {
          page,
        }
      );

      if (m8PartnerIncomeHistoryRecords.length > 0) {
        m8PartnerIncomeHistoryRecords.forEach(
          (m8PartnerIncomeHistoryRecord) => {
            partnerFinanceMonthReports.push(
              normalizeM8PartnerIncomeHistoryRecord(
                m8PartnerIncomeHistoryRecord
              ).toPartnerFinanceMonthReport()
            );
          }
        );
      } else {
        break;
      }
    }
  }

  return {
    accountInfo,
    profileInfo,
    partnerProfile,
    partnerFinances,
    partnerFinanceMonthReports,
    partnerCode,
    cancelledClientsCount,
    org,
    person,
  };
};
